import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-home\"><defs><style>#icon-home .a{fill:#fff;}</style></defs><path class=\"a\" d=\"M82.626,72.55l-8.381-8.369a.62.62,0,0,0-.875,0L64.99,72.55a.618.618,0,0,0,.437,1.055h1.344v7.109A1.288,1.288,0,0,0,68.059,82H71.23V79.431a1.288,1.288,0,0,1,1.288-1.286h2.576a1.288,1.288,0,0,1,1.288,1.286V82h3.151a1.288,1.288,0,0,0,1.288-1.286V73.6h1.364A.619.619,0,0,0,82.626,72.55Z\" transform=\"translate(-64.807 -64)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol